import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined, checkPositiveInteger } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
export const intraDayScheduleNameMaxLength = 250;
export const intraDayScheduleTimeSlotNameMaxLength = 255;
export var TimeSlotType;
(function (TimeSlotType) {
    TimeSlotType["Operational"] = "Operational";
    TimeSlotType["Travel"] = "Travel";
    TimeSlotType["Wait"] = "Wait";
    TimeSlotType["Fasting"] = "Fasting";
})(TimeSlotType || (TimeSlotType = {}));
/**
 * @return the built ScheduledDay entity
 */
export function toIntraDaySchedule(intraDaySchedule) {
    var _a;
    checkDefined(intraDaySchedule.scheduleOfActivitiesId, 'IntraDaySchedule', 'scheduleOfActivitiesId');
    checkDefined(intraDaySchedule.scheduledDayId, 'IntraDaySchedule', 'scheduledDayId');
    return {
        ...toBaseStudyEntity(intraDaySchedule, StudyEntityType.IntraDaySchedule),
        name: intraDaySchedule.name,
        scheduledDayId: intraDaySchedule.scheduledDayId,
        scheduleOfActivitiesId: intraDaySchedule.scheduleOfActivitiesId,
        timeSlots: (_a = intraDaySchedule.timeSlots) === null || _a === void 0 ? void 0 : _a.map(ts => toTimeSlot(ts)),
    };
}
/**
 * @return the built ScheduledDay entity
 */
export function toTimeSlot(timeSlot) {
    var _a, _b;
    if (timeSlot.duration != null) {
        checkPositiveInteger(timeSlot.duration, 'TimeSlot.duration');
    }
    return {
        name: timeSlot.name,
        duration: timeSlot.duration,
        activityIds: (_a = timeSlot.activityIds) === null || _a === void 0 ? void 0 : _a.map(aid => aid),
        type: (_b = timeSlot.type) !== null && _b !== void 0 ? _b : TimeSlotType.Operational,
    };
}
//# sourceMappingURL=intra-day-shchedule.js.map